import React, { useEffect, useState } from 'react';
import { Table } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { RPDMetricColumn } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/RPDCloums';
import { tableDataFormatKMB } from '@/pages/intelligence/utils/commonUtils';
import { sortTableByMetric } from '@/pages/intelligence/utils/tableUtils';
import { DateColumns } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/DateCloums';
import { useIntl } from 'umi';
import { useMobileOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useMobileOptionList';

const { pageable } = Table.addons;

const TrendsCard = (props: any) => {
  const {
    tableData = [],
    asForDate = '',
    chartSegment,
    // pageSortAttr,
    dateType,
    onTableSortChage,
    pageSortAttr: defaultPageSortAttr,
    entityType = '',
    source,
  } = props;

  const { formatMessage } = useIntl();
  const [sortTableData, setSortTableData] = useState(tableData);
  const [pageSortAttr, setPageSortAttr] = useState(defaultPageSortAttr);
  // const [pageSortAttr, setPageSortAttr] = useState({
  //   currentSortValue: 'desc',
  //   currentSortMetric: 'date',
  //   currentRatioType: 0,
  // });
  const {
    // tablePageIndex,
    // tablePageSize,
    currentSortValue,
    currentSortMetric,
    currentRatioType,
    // currentOrderSource,
  } = pageSortAttr || {};
  const { rpdListDetail } = useMobileOptionList({ asForDate });

  // useEffect(() => {
  //   setSortTableData(tableData);
  // }, [JSON.stringify(tableData)]);

  useEffect(() => {
    onSortChage({
      sortMetric: currentSortMetric,
      sortVal: currentSortValue,
      ratioType: currentRatioType,
    });
  }, [tableData]);

  const handleSortChange = (e: SortByItemType) => {
    onTableSortChage?.(e);
    onSortChage(e);
  };

  const onSortChage = (e: SortByItemType) => {
    console.log(e);
    setPageSortAttr({
      currentSortValue: e.sortVal,
      currentSortMetric: e.sortMetric,
      currentRatioType: e.ratioType,
    });
    const sortTable = sortTableByMetric({
      tableData,
      sortParams: e,
      valueProperty: 'value_str',
      metricProperty: 'metric',
    });
    setSortTableData(sortTable.slice(0));
  };

  const getMetricValueOfCvm = (cvm: any, metricKey: string) => {
    const metrics = cvm?.metrics || [];
    const metric = metrics.find((item: any) => {
      return item?.metric === metricKey;
    });
    return tableDataFormatKMB(metric?.value_str);
  };

  const getMetricCloums = () => {
    const metricCloums: any[] = [];

    rpdListDetail.forEach((t) => {
      metricCloums.push(
        RPDMetricColumn(
          {
            width: t.width,
            width_cn: t?.width_cn ?? t.width,
            // dataSource: source, //source === 'ogdb' ? 'databarin' : source,
            title: t.title,
            textContent: t.textContent,
            key: `${t.key}`,
            metricKey: t?.metricKey || t?.key,
            sortMetric: t.key,
            currentSortValue,
            currentSortKey: `${currentSortMetric}`,
            isNoDropdown: !(chartSegment === t.key),
            onSortChage: handleSortChange,
            getMetricValueOfCvm,
            entityType,
          },
          source,
        ),
      );
    });
    return metricCloums;
  };

  return (
    <>
      <Table
        //   verticalTop
        bordered="all"
        records={sortTableData}
        className="dbi-mobileGames-details-table"
        columns={[
          DateColumns({
            key: 'date',
            sortMetric: 'date',
            title: formatMessage({ id: `dbi_date` }),
            currentSortMetric,
            currentSortValue,
            dateType,
            onSortChage: handleSortChange,
            width: 180,
          }),
          ...getMetricCloums(),
        ]}
        addons={[
          pageable({
            stateTextVisible: true,
            pageSizeVisible: sortTableData?.length > 5,
            pageIndexVisible: sortTableData?.length > 5,
            jumpVisible: sortTableData?.length > 5,
            endJumpVisible: sortTableData?.length > 5,
            // pageSizeOptions: [5, 10, 15],
            pageSizeOptions: [10, 20, 30, 50, 100, 200],
            stateText: formatMessage(
              { id: 'dbi_pagination_total' },
              { total: sortTableData?.length ?? 0 },
            ),
          }),
        ]}
      />
    </>
  );
};

export default TrendsCard;
